import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class WorkOrderLinkResultDto {
    workOrderId: number;
    status: string;

    @Type(() => UserNameDisplayResultDto)
    responsible: UserNameDisplayResultDto;

    reference: string;
    jobDescription: string;

    // transient varible
    isSelected: boolean;
}
